import $ from 'jquery'
import "jquery-modal/jquery.modal.css"
import "jquery-modal/jquery.modal.js"
import "../scss/modal.scss"
$(function() {
   //do things here.
});